/**
 * Multiselect de contas:
 * - lista vazia = todas as contas (sem restrição)
 * - lista parcial = filtra pelos códigos selecionados
 */

export function todosCodigos(opcoes) {
  return (opcoes || []).map((o) => o.codigo);
}

export function extrairCodigosContasFromLinhas(linhas) {
  const set = new Set();
  for (const linha of linhas || []) {
    const cod = String(linha.ecdContaContabil || "").trim();
    if (cod) set.add(cod);
  }
  return Array.from(set);
}

export function isContaMarcada(codigo, selecionadas) {
  return (selecionadas || []).includes(codigo);
}

export function alternarContaSelecao(codigo, selecionadas) {
  const lista = selecionadas || [];
  if (lista.includes(codigo)) {
    return lista.filter((c) => c !== codigo);
  }
  return [...lista, codigo];
}

/** Marca todas as contas disponíveis. */
export function acaoSelecionarTodas(opcoes) {
  return todosCodigos(opcoes);
}

/** Marca apenas contas de resultado (`contaResultado`). */
export function acaoSelecionarContasResultado(opcoes) {
  return (opcoes || [])
    .filter((o) => Boolean(o.contaResultado))
    .map((o) => o.codigo);
}

/** Desmarca todas as contas. */
export function acaoLimparContas() {
  return [];
}

export function textoTriggerContas(selecionadas, opcoes) {
  const total = opcoes?.length ?? 0;
  const qtd = selecionadas?.length ?? 0;
  if (qtd === 0 || qtd === total) return `Todas as contas (${total})`;
  return `${qtd} de ${total} conta(s)`;
}
